import React, { useState } from 'react';
import { Button } from '../../../components';
import warning from '../../../assets/svg/warning.svg';
import { describeError, UiError } from './errors';
import ErrorBox from './ErrorBox';
import '../../Modal/Modal.module.scss';

interface Props {
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
  /** Resolves on success (the parent closes the modal); a rejection is rendered inside the dialog. */
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

/** Modal body for activate / deactivate / duplicate / delete, same markup as the other management confirms. */
const ConfirmDialog: React.FC<Props> = ({
  title, message, confirmLabel, danger = false, onConfirm, onClose,
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<UiError | null>(null);

  const confirm = () => {
    setBusy(true);
    setError(null);
    onConfirm()
      .catch((e) => {
        setError(describeError(e));
        setBusy(false);
      });
  };

  return (
    <>
      <img src={warning} alt="warning" />
      <h2>{title}</h2>
      <p>{message}</p>
      <ErrorBox error={error} />
      <div className="modalButtonWrapper">
        <Button buttonType="button" onClick={onClose} disabled={busy}>Cancel</Button>
        <Button buttonType="button" className={danger ? 'ev-btn-danger' : ''} onClick={confirm} disabled={busy}>
          {busy ? 'Working…' : confirmLabel}
        </Button>
      </div>
    </>
  );
};

export default ConfirmDialog;
